import { useApi } from '@/api';
import { KpiCard, Page, PageSkeleton, WalletCard } from '@/components';
import { farmMapping } from '@/utils/farms';
import { Flex, Heading } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import HistoricTabs from './HistoricTabs';
import WalletEventsTable from './WalletEventsTable';

export default function FarmDespositorPage() {
  const { address, walletAddress } = useParams();
  const [data, error] = useApi({
    url: `/farms/${address}/depositors/${walletAddress}/`
  });

  if (error) {
    throw error;
  }
  if (data) {
    return (
      <Page title={<Heading size="1">Supplier</Heading>}>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <WalletCard address={data.wallet_address} />
          <KpiCard
            title="Staked"
            variant="usds"
            data={data}
            field="balance"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: {
                    name: data.staking_token_symbol,
                    address: data.staking_token_address
                  }
                }
              }
            }}
          />
          {farmMapping(data.address) !== 'chronicle_farm' ? (
            <KpiCard
              title="Estimated Reward"
              variant="sky"
              data={data}
              field="reward_balance"
              options={{
                endlessPerSecond: Number(data.reward_tokens_per_second),
                valueOptions: {
                  currencyValueOptions: {
                    currency: {
                      name: data.rewards_token_symbol,
                      address: data.rewards_token_address
                    }
                  }
                }
              }}
            />
          ) : (
            <KpiCard
              title="Estimated Points"
              data={data}
              field="reward_balance"
              options={{
                endlessPerSecond: Number(data.reward_tokens_per_second)
              }}
            />
          )}
        </Flex>
        <HistoricTabs address={address} walletAddress={walletAddress} />
        {farmMapping(data.address) !== 'chronicle_farm' && (
          <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
            <KpiCard
              title="Claimed Rewards"
              data={data}
              field="claimed"
              options={{
                valueOptions: {
                  currencyValueOptions: {
                    currency: {
                      name: data.rewards_token_symbol,
                      address: data.rewards_token_address
                    }
                  }
                }
              }}
            />
            <KpiCard
              title="Unclaimed Rewards"
              data={data}
              field="unclaimed"
              options={{
                valueOptions: {
                  currencyValueOptions: {
                    currency: {
                      name: data.rewards_token_symbol,
                      address: data.rewards_token_address
                    }
                  }
                }
              }}
            />
          </Flex>
        )}

        <WalletEventsTable address={address} walletAddress={walletAddress} />
      </Page>
    );
  }
  return <PageSkeleton />;
}
